import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import ruRU from "antd/locale/ru_RU";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import { configureAxiosAuth } from "./services/configureAxiosAuth";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/reset.module.scss";
import "./styles/theme.scss";

configureAxiosAuth();
dayjs.locale("ru");

const root = ReactDOM.createRoot(
    document.getElementById("main") as HTMLElement
);
root.render(
    <React.StrictMode>
        <ConfigProvider locale={ruRU}>
            <App />
        </ConfigProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
